import { VectorStyle } from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';

export const TWC_METARS_VECTOR_STYLE: VectorStyle = {
  layers: [
    {
      layout: {
        'icon-image': [
          'concat', // Concatenate strings to make each TAF_WIND_BARB
          'METAR_Wind_Barb_',
          [
            'to-string',
            ['*', ['floor', ['/', ['*', ['get', 'wspd'], 1.94384], 5]], 5]
          ], // Wind speed in multiples of 5 by converting m/s to knots
          'kts_',
          ['get', 'flight_rule'] // Append flight rule at the end
        ],
        'icon-rotate': ['get', 'wdir'],
        'icon-size': 0.6,
        'icon-allow-overlap': true
      },
      paint: {},
      source: 'twc',
      minzoom: 0,
      'source-layer': 'source-layer',
      id: 'metas',
      filter: ['all', ['has', 'wspd'], ['has', 'wdir'], ['has', 'flight_rule']],
      type: 'symbol',
      maxzoom: 28
    }
  ],
  sprite: `assets/weather/sprites/METARs`
};
